import React from "react";
import { FormGroup } from "react-bootstrap";
import Rating from "react-rating";
import styles from "./Ratings.scss";

class Ratings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      rating: this.props.rating
    };
  }

  render() {
    const { text, emptyIcon, filledIcon } = this.props;

    return (
      <FormGroup className={styles.ratings}>
        <div className={styles.text}>{text}</div>
        <Rating
          emptySymbol={<img src={emptyIcon} className={styles.icon} />}
          fullSymbol={<img src={filledIcon} className={styles.icon} />}
          initialRating={this.state.rating}
          readonly
        />
      </FormGroup>
    );
  }
}

export default Ratings;



// WEBPACK FOOTER //
// ./src/routes/admin/project/reviews/components/Ratings.js